import {TextField} from "@mui/material";


export const EditItemText = ({ item, UpdateItem }: any) => {
    return (

        <div className='p-5 bg-slate-100'>
            <div className='text-right'>
                <div className='text-right p-1 text-[12px] m-2'>لیبل</div>
                <input
                    defaultValue={item!.data?.label}
                    onChange={(e) => {
                        const value = e.target.value;
                        UpdateItem((prevState: { data: any; }): any => ({
                            ...prevState,
                            data: {
                                ...prevState.data,
                                label: value,
                            },
                        }));
                    }}

                    type="text"
                    className="py-3 px-4 block w-full border-gray-200 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600"
                    placeholder="لیبل" />


            </div>
            <div className='text-right'>
                <div className='text-right p-1 text-[12px] m-2'>راهنما</div>
                <input
                    defaultValue={item!.data?.placeholder}
                    type="text"
                    onChange={(e) => {
                        const value = e.target.value;
                        UpdateItem((prevState: { data: any; }): any => ({
                            ...prevState,
                            data: {
                                ...prevState.data,
                                placeholder: value,
                            },
                        }));
                    }}

                    className="py-3 px-4 block w-full border-gray-200 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600"
                    placeholder="راهنما" />

            </div>
            <div className='text-right'>
                <div className='text-right p-1 text-[12px] m-2'>اجبار</div>
                <select
                    defaultValue={item!.data?.reqiured}
                    onChange={(e) => {
                        const value = e.target.value;
                        UpdateItem((prevState: { data: any; }): any => ({
                            ...prevState,
                            data: {
                                ...prevState.data,
                                reqiured: value,
                            },
                        }));
                    }}

                    className='w-full p-1'>
                    <option value="true">بلی</option>
                    <option value="false">خیر</option>

                </select>

            </div>
            <div className='text-right'>
                <div className='text-right p-1 text-[12px] m-2'>نوع ورودی</div>
                <p
                    defaultValue={item!.data?.mode}
                    onChange={(e:any) => {
                        const value = e.target.value;
                        UpdateItem((prevState: { data: any; }): any => ({
                            ...prevState,
                            data: {
                                ...prevState.data,
                                mode: value,
                            },
                        }));
                    }}

                    className='w-full p-1'>
                    <option value={'text'}>نوشته</option>
                    <option value={'number'}>عدد</option>
                    <option value={'color'}>رنگ</option>

                </p>

            </div>

        </div>
    )
}


export const EditCheckBox = ({ item, UpdateItem }: any) => {
    return (

        <div className='p-5 bg-slate-100'>
            <div className='text-right'>

                <div className='text-right p-1 text-[12px] m-2'>توضیحات</div>
                <textarea
                    defaultValue={item!.data?.label}
                    onChange={(e) => {
                        const value = e.target.value;
                        UpdateItem((prevState: { data: any; }): any => ({
                            ...prevState,
                            data: {
                                ...prevState.data,
                                description: value,
                            },
                        }));
                    }}


                    className="py-3 px-4 block w-full border-gray-200 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600"
                    placeholder=""/>


            </div>
            <div className='text-right'>
                <div className='text-right p-1 text-[12px] m-2'>لیبل</div>
                <input
                    defaultValue={item!.data?.label}
                    onChange={(e) => {
                        const value = e.target.value;
                        UpdateItem((prevState: { data: any; }): any => ({
                            ...prevState,
                            data: {
                                ...prevState.data,
                                label: value,
                            },
                        }));
                    }}

                    type="text"
                    className="py-3 px-4 block w-full border-gray-200 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600"
                    placeholder=""/>


            </div>
            <div className='text-right'>
                <div className='text-right p-1 text-[12px] m-2'>گزینه ها (با "-" از هم جدا کنید)</div>
                <textarea


                    defaultValue={item!.data?.options}
                    onChange={(e) => {
                        const value = e.target.value;
                        UpdateItem((prevState: { data: any; }): any => ({
                            ...prevState,
                            data: {
                                ...prevState.data,
                                options: value,
                            },
                        }));
                    }}

                    className="py-3 px-4 block w-full border-gray-200 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600"
                    placeholder=""/>


            </div>


        </div>
    )
}


export const EditRadioBox = ({item, UpdateItem}: any) => {
    return (

        <div className='p-5 bg-slate-100'>
            <div className='text-right'>
                <div className='text-right p-1 text-[12px] m-2'>توضیحات</div>
                <textarea
                    defaultValue={item!.data?.label}
                    onChange={(e) => {
                        const value = e.target.value;
                        UpdateItem((prevState: { data: any; }): any => ({
                            ...prevState,
                            data: {
                                ...prevState.data,
                                description: value,
                            },
                        }));
                    }}


                    className="py-3 px-4 block w-full border-gray-200 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600"
                    placeholder=""/>


            </div>
            <div className='text-right'>
                <div className='text-right p-1 text-[12px] m-2'>گزینه ها (با "-" از هم جدا کنید)</div>
                <textarea


                    defaultValue={item!.data?.options}
                    onChange={(e) => {
                        const value = e.target.value;
                        UpdateItem((prevState: { data: any; }): any => ({
                            ...prevState,
                            data: {
                                ...prevState.data,
                                options: value,
                            },
                        }));
                    }}

                    className="py-3 px-4 block w-full border-gray-200 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600"
                    placeholder=""/>


            </div>

        </div>
    )
}


export const EditItemTextArea = ({item, UpdateItem}: any) => {
    return (

        <div className='p-5 bg-slate-100'>
            <div className='text-right'>
                <div className='text-right p-1 text-[12px] m-2'>لیبل</div>
                <input
                    defaultValue={item!.data?.label}
                    onChange={(e) => {
                        const value = e.target.value;
                        UpdateItem((prevState: { data: any; }): any => ({
                            ...prevState,
                            data: {
                                ...prevState.data,
                                label: value,
                            },
                        }));
                    }}

                    type="text"
                    className="py-3 px-4 block w-full border-gray-200 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600"
                    placeholder="لیبل" />


            </div>
            <div className='text-right'>
                <div className='text-right p-1 text-[12px] m-2'>راهنما</div>
                <input
                    defaultValue={item!.data?.placeholder}
                    type="text"
                    onChange={(e) => {
                        const value = e.target.value;
                        UpdateItem((prevState: { data: any; }): any => ({
                            ...prevState,
                            data: {
                                ...prevState.data,
                                placeholder: value,
                            },
                        }));
                    }}

                    className="py-3 px-4 block w-full border-gray-200 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600"
                    placeholder="راهنما" />

            </div>
            <div className='text-right'>
                <div className='text-right p-1 text-[12px] m-2'>اجبار</div>
                <select
                    defaultValue={item!.data?.reqiured}
                    onChange={(e) => {
                        const value = e.target.value;
                        UpdateItem((prevState: { data: any; }): any => ({
                            ...prevState,
                            data: {
                                ...prevState.data,
                                reqiured: value,
                            },
                        }));
                    }}

                    className='w-full p-1'>
                    <option value="true">بلی</option>
                    <option value="false">خیر</option>

                </select>

            </div>


        </div>
    )
}

export const RadioBox = ({ item }: any) => {
    return (
        <div className="" dir='ltr'>
            <div className='text-right text-[15px]'>{item?.data?.description}</div>
            <div className="inline-flex items-center" >
                <label className="relative flex items-center cursor-pointer" >
                    <input
                        name="color"
                        type="radio"
                        className="peer h-5 w-5 cursor-pointer appearance-none rounded-full border border-slate-300 checked:border-slate-400 transition-all"
                        id="slate-800"

                    />
                    <span className='pr-3 pl-3'>dsd</span>

                </label>

                <label className="relative flex items-center cursor-pointer" >


                </label>
            </div>
        </div>
    )
}